// extracted by mini-css-extract-plugin
module.exports = {"successPopup":"success-popup_successPopup__206or","successPopupContent":"success-popup_successPopupContent__2nYri","successPopupBtn":"success-popup_successPopupBtn__1pGyP"};